export enum JobTabs {
  OVERVIEW,
  DETAIL,
  PROGRESSES,
  JOB_SETTING_MAIL,
  JOB_SETTING_SEMINAR,
  SALES,
  MEMO
}

export enum JobTabsForIntakeCa {
  OVERVIEW,
  DETAIL,
  JOB_SETTING_MAIL,
  MEMO
}
